import { createApp } from 'vue'
import Allinpay from '../views/allinpay/Allinpay.vue'
import { setupI18n } from '../i18n'
import { PublishPaymentMethodItem } from '../apis/types/payment'
import { createPaymentDropinOrder } from '../apis/payment'
import { PAYMENT_APP_VERSION } from '../const'
import AllinpayQR from '../views/allinpay/AllinpayQR.vue'

export const createAllinpayDropIn = (config: {
  clientId: string
  language?: string
  sdkVersion?: string
  orderInfo: any
  onSubmit?: () => void
  onError?: (error: any) => void
  onCreateOrder?: (result: any) => void
  // onClickComplete?: () => void
  onCompleted?: () => void
}) => {
  const { orderInfo, onSubmit, onError, onCreateOrder, onCompleted } = config

  // 创建订单
  const createOrder = async (payment_method_id: string) => {
    const result = await createPaymentDropinOrder({
      dropin_channel_data: JSON.stringify({}),
      payment_channel_type: 7,
      payment_method_id,
      sys_order_id: orderInfo?.sys_order_id,
      sdk_version: config.sdkVersion || PAYMENT_APP_VERSION,
    })

    onCreateOrder?.(result)

    return result
  }

  // 设置支付方式
  const setup = async (containerId: string, paymentMethod: PublishPaymentMethodItem) => {
    const app = createApp(Allinpay, {
      orderInfo,
      createOrder: () => createOrder(paymentMethod.payment_method_id),
      onSubmit,
      onError,
      onCompleted,
    })

    setupI18n(app)

    app.mount(containerId)
  }

  // 只显示二维码
  const setupOnlyQRCode = async (containerId: string, paymentMethod: PublishPaymentMethodItem) => {
    const app = createApp(AllinpayQR, {
      createOrder: () => createOrder(paymentMethod.payment_method_id),
    })

    app.mount(containerId)
  }

  return {
    setup,
    setupOnlyQRCode,
  }
}
